import React, { useState } from "react";
import styles from "./Submission.module.scss";
import IconButton from "../../../../components/ButtonIcon/ButtonIcon";
import ems_logo from "../../../../../../images/v2/ems.png";
import nuvei_loggo from "../../../../../../images/v2/nuvei.png";
import StatusDot from "../../../../components/StatusDot/StatusDot";
import JSONPretty from "react-json-pretty";
import moment from "moment";
import FileIcon from "../../../../assets/svg/icons/common/file";

function SubmittedItem({ history }) {
  const [expanded, setExpanded] = useState(false);
  const [expandResponse, setExpandResponse] = useState(false);

  const getLogo = (processor) => {
    if (processor == "ems") return ems_logo;
    if (processor == "nuvei") return nuvei_logo;
    if (processor == "nab") return nab_logo;
    if (processor == "priority") return priority_logo;
  };

  const status = history ? history.status : null;

  const submittedDocuments = history ? JSON.parse(history.documents) : [];
  const application_status = history ? history.application_status : null;

  return (
    <>
      <div className={styles.submission_item}>
        <div className={styles.item_head}>
          <input type="checkbox" />
          <IconButton onClick={() => setExpanded(!expanded)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M11.3537 8.35403L6.35372 13.354C6.30727 13.4005 6.25212 13.4373 6.19142 13.4625C6.13072 13.4876 6.06567 13.5006 5.99997 13.5006C5.93428 13.5006 5.86922 13.4876 5.80852 13.4625C5.74783 13.4373 5.69268 13.4005 5.64622 13.354C5.59977 13.3076 5.56292 13.2524 5.53778 13.1917C5.51263 13.131 5.49969 13.066 5.49969 13.0003C5.49969 12.9346 5.51263 12.8695 5.53778 12.8088C5.56292 12.7481 5.59977 12.693 5.64622 12.6465L10.2931 8.00028L5.64622 3.35403C5.5524 3.26021 5.49969 3.13296 5.49969 3.00028C5.49969 2.8676 5.5524 2.74035 5.64622 2.64653C5.74004 2.55271 5.86729 2.5 5.99997 2.5C6.13265 2.5 6.2599 2.55271 6.35372 2.64653L11.3537 7.64653C11.4002 7.69296 11.4371 7.74811 11.4623 7.80881C11.4874 7.86951 11.5004 7.93457 11.5004 8.00028C11.5004 8.06599 11.4874 8.13105 11.4623 8.19175C11.4371 8.25245 11.4002 8.30759 11.3537 8.35403Z"
                fill="#3A383F"
              />
            </svg>
          </IconButton>
        </div>

        <div className={styles.body}>
          <div className={styles.processor}>
            <img src={getLogo(history.service)} />
            <h6>{history.service}</h6>
          </div>

          <div className={styles.action}>
            <p>
              Sent: {moment(history.created_at).format("MMM D, YYYY | H:mm A")}
            </p>
          </div>
        </div>
      </div>

      <div
        className={`${styles.submission_data} ${expanded ? styles.expanded : ""}`}
      >
        {expanded && (
          <>
            <div className={styles.statuses}>
              <div className={styles.status_item}>
                <span className={styles.name}>API Status</span>
                <div className={styles.status_color}>
                  <StatusDot color="#26A1F2" />
                  <span>
                    {status != null
                      ? status == 1
                        ? "Sent"
                        : status == 2
                          ? "Pending"
                          : "Failed"
                      : null}{" "}
                  </span>
                </div>
              </div>

              <div className={styles.status_item}>
                <span className={styles.name}>Application Status</span>
                <div className={styles.status_color}>
                  <StatusDot color="#F4BA3B" />
                  <span>{application_status}</span>
                </div>
              </div>
            </div>
            <div className={styles.submission_data_list}>
              {submittedDocuments?.map((doc) => {
                <div className={styles.list_item}>
                  <FileIcon />
                  <span>{doc}</span>
                </div>;
              })}
            </div>

            <div className={styles.response_container}>
              <div className={styles.header}>
                <IconButton onClick={() => setExpandResponse(!expandResponse)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M13.3537 6.35403L8.35372 11.354C8.30729 11.4005 8.25214 11.4374 8.19144 11.4626C8.13074 11.4877 8.06568 11.5007 7.99997 11.5007C7.93427 11.5007 7.8692 11.4877 7.8085 11.4626C7.7478 11.4374 7.69266 11.4005 7.64622 11.354L2.64622 6.35403C2.5524 6.26021 2.49969 6.13296 2.49969 6.00028C2.49969 5.8676 2.5524 5.74035 2.64622 5.64653C2.74004 5.55271 2.86729 5.5 2.99997 5.5C3.13265 5.5 3.2599 5.55271 3.35372 5.64653L7.99997 10.2934L12.6462 5.64653C12.6927 5.60007 12.7478 5.56322 12.8085 5.53808C12.8692 5.51294 12.9343 5.5 13 5.5C13.0657 5.5 13.1307 5.51294 13.1914 5.53808C13.2521 5.56322 13.3073 5.60007 13.3537 5.64653C13.4002 5.69298 13.437 5.74813 13.4622 5.80883C13.4873 5.86953 13.5003 5.93458 13.5003 6.00028C13.5003 6.06598 13.4873 6.13103 13.4622 6.19173C13.437 6.25242 13.4002 6.30757 13.3537 6.35403Z"
                      fill="#3A383F"
                    />
                  </svg>
                </IconButton>
                <span>Response</span>
              </div>

              {expandResponse && (
                <div className={styles.body}>
                  <div className={styles.submitted_response}>
                    <h6>Submitted Data</h6>
                    <div className={styles.data}>
                      <JSONPretty
                        id="json-pretty"
                        data={JSON.parse(history.data)}
                      ></JSONPretty>
                    </div>
                  </div>

                  <div className={styles.submitted_response}>
                    <h6>Response</h6>
                    <div className={styles.data}>
                      <JSONPretty
                        id="json-pretty"
                        data={JSON.parse(history.response)}
                      ></JSONPretty>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default SubmittedItem;
